import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../core/service/v2/service/save/abstractSaveOne.service';
import {ExamFormModel} from '../../api/model/exam-form.model';
import {ExamFormSavePayload} from './payload/examFormSave.payload';
import {ExamFormDataServiceAdapter} from './ngrx/examFormDataService.adapter';
import {ExamFormRepository} from './ngrx/examForm.repository';


@Injectable()
export class ExamFormSaveService extends AbstractSaveOneService<ExamFormModel, ExamFormSavePayload> {

    constructor(repository: ExamFormRepository, dataServiceAdapter: ExamFormDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
